import { render, staticRenderFns } from "./DmsPlayerEmbed.vue?vue&type=template&id=55b8dd10&scoped=true&"
import script from "./DmsPlayerEmbed.vue?vue&type=script&lang=js&"
export * from "./DmsPlayerEmbed.vue?vue&type=script&lang=js&"
import style0 from "./DmsPlayerEmbed.vue?vue&type=style&index=0&id=55b8dd10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b8dd10",
  null
  
)

export default component.exports